<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
          </div>
          <h3 class="mt-5">Individual Analysis Report</h3>
          <h3 class="text-blue-heading mt-5">{{ trainingDetails.title }}</h3>

          <div class="row mt-5">
            <div class="col-sm-6">
              <h5>Select an individual to view</h5>
              ({{ allTrainees.length }})
            </div>
            <div class="col-sm-6">
              <h5>Hints</h5>
              <span class="text-success">Green: Correct</span> ,
              <span class="text-danger">Red: Incorrect</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 mt-5" v-if="allTrainees">
              <div v-for="(trainee, tIndex) in allTrainees" v-bind:key="tIndex">
                <h5
                  :id="trainee.trainee.user_trainee_id"
                  class="text-blue font-weight-bold common_trigger"
                  v-if="trainee.trainee.userstrainee.name && tIndex == 0"
                  @click="loadAssesment(trainee.trainee.user_trainee_id)"
                >
                  {{ trainee.trainee.userstrainee.name }}
                </h5>
                <h5
                  :id="trainee.trainee.user_trainee_id"
                  v-else-if="tIndex > 0 && trainee.trainee.userstrainee.name"
                  class="common_trigger"
                  @click="loadAssesment(trainee.trainee.user_trainee_id)"
                >
                  {{ trainee.trainee.userstrainee.name }}
                </h5>
              </div>
            </div>
            <div class="col-sm-9 col-md-9 mt-5">
              <div
                v-for="(question, qIndex) in Assesment"
                v-bind:key="qIndex + 5"
              >
                <h6 class="pointer-class">
                  <b>Q{{ qIndex + 1 }}. {{ question.question.title }}</b>
                </h6>
                <div class="d-flex justify-content-start ">
                  <div
                    class=""
                    v-for="(pre, preIndex) in preFeedback"
                    v-bind:key="preIndex + 2"
                  >
                    <div
                      class="pr-5"
                      v-if="question.question_id == pre.question_id"
                    >
                    
                      <h6 class="mt-2 mb-0">Pre Assessment</h6>
                      <p class="text-success" v-if="pre.options && pre.options.status == 1">
                        <span> </span>
                        {{ pre.options.title }}
                      </p>
                      <p class="text-danger" v-else>
                        <span> </span>
                        {{ pre.options.title }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-for="(post, prpkIndex) in postFeedback"
                    v-bind:key="'post' + prpkIndex + 1"
                  >
                    <div
                      class=""
                      v-if="post.question_id == question.question_id"
                    >
                      <h6 class="mt-2 mb-0">Post Assessment</h6>
                      <p class="text-success" v-if="post.options && post.options.status == 1">
                        <span> </span>
                        {{ post.options.title }}
                      </p>
                       <p class="text-danger" v-else>
                        <span> </span>
                        {{ post.options.title }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import $ from 'jquery';

export default {
  data: () => ({
    isActve1: 1,
    trainingCode: "",
    trainingID: "",
    allTrainees: [],
    trainingDetails: [],
    Questions: [],
    preFeedback: [],
    postFeedback: [],
    PostQuestions: [],
    PreSelection: [],
    Assesment: [],
    PostSelection: [],
    isSidebar: false,
    colorx: "warning"
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  created() {},
  methods: {
    showTraineesPreAssesment: function showTraineesPreAssesment(
      tId,
      traineeuserId
    ) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/show/trainee-preassesment/report/" +
            traineeuserId +
            "/" +
            tId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            this.preFeedback = response.data.prefeedback;
            this.Assesment = response.data.assesment;
          }
        });
    },
    showTraineesPostAssesment: function showTraineesPostAssesment(
      tId,
      traineeuserId
    ) {
      
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/show/trainee-postassesment/report/" +
            traineeuserId +
            "/" +
            tId
       
        )
        .then(response => {
          if(response.data.unAuth){
             this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data) {
            this.postFeedback = response.data.prefeedback;
          }
        });
    },
    loadAssesment(trainee_id) {
      $(".common_trigger").removeClass("text-blue font-weight-bold");
      $("#" + trainee_id).addClass("text-blue font-weight-bold");

      this.openLoading();
      this.showTraineesPreAssesment(this.trainingID, trainee_id);
      this.showTraineesPostAssesment(this.trainingID, trainee_id);
      this.closeLoading();
    },
    showTrainees: function showTrainees(tId) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/single/training/traineedetails/report/get/" +
            tId
       
        )
        .then(response => {
          if(response.data.unAuth){
             this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
             this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allTrainees = response.data.trainees;
          //load first trainee assesment
          if (
            this.allTrainees &&
            this.allTrainees[0] != undefined &&
            this.allTrainees[0].trainee != undefined
          ) {
            this.showTraineesPreAssesment(
              tId,
              this.allTrainees[0].trainee.user_trainee_id
            );
            this.showTraineesPostAssesment(
              tId,
              this.allTrainees[0].trainee.user_trainee_id
            );
          }
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
       
      this.$vs.loading.close();
    }
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data && response.data.training) {
          this.trainingDetails = response.data.training;
          this.trainingID = response.data.training.id;
          this.showTrainees(response.data.training.id);
        }
      });
  }
};
</script>

<style scoped>
.text-blue {
  color: #00a4ea;
  cursor: pointer !important;
  background-color: rgba(60, 60, 250, 0.055); 
}
.text-blue-heading {
  color: #00a4ea;
}
.btn-report {
  background-color: #6488d2 !important;
  border-radius: 0px !important;
  padding: 3px 30px !important;
}
h5{
  cursor: pointer;
}
h5:hover{
  background-color: rgba(60, 60, 250, 0.178);
}
</style>
